export default __webpack_public_path__ + "static/media/Notification.d657a3db.png";